import { LinkElement } from '@/cmsComponents/LinkElement';
import MarkdownCMSModule from '@/cmsComponents/MarkdownCMSModule';
import { Alignment } from '@/cmsComponents/constants';
import cx from 'classnames';
import { IFrequentlyAskedQuestion } from 'types/cms';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import styles from './FaqAccordionItem.module.scss';

export interface FaqAccordionItemProps {
  data: IFrequentlyAskedQuestion;
  open: boolean;
  onToggle: () => void;
}

export const FaqAccordionItem = ({ data, open, onToggle }: FaqAccordionItemProps) => (
  <div className={cx(styles.item, { [styles.open]: open })}>
    <button
      className={styles.questionRow}
      onClick={onToggle}
      aria-expanded={open}
      aria-controls={`faq-answer-${data.id}`}
    >
      <span className={styles.question}>{data.question}</span>
      <ExpandMoreIcon className={cx(styles.icon, { [styles.iconOpen]: open })} />
    </button>
    {open && (
      <div className={styles.answer} id={`faq-answer-${data.id}`}>
        <MarkdownCMSModule source={data.answer} />
        {data.button_URL && (
          <LinkElement
            link={data.button_URL}
            linkStyle={data.button_style}
            linkText={data.button_text}
            align={Alignment.Left}
          />
        )}
      </div>
    )}
  </div>
);

export default FaqAccordionItem;
